import React, {useEffect} from "react";

// IMPORT COMPONENTS
import Navbar from "components/navBar/Navbar";
import MediaQuery from "react-responsive";
import SidebarDesktop from "components/sidebar/sidebarDesktop";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import EmptyStateCompany from "components/emptyState";
import Intercom from '@intercom/messenger-js-sdk';
import CryptoJS from 'crypto-js';
import useFetchData from "../../hooks/useFetchData";
import UseContext from "hooks/useContext";
import {SIDE_PANEL_MODAL_TYPES} from "components/modal/dataModal";

const PageForm = (props) => {
    const {userData} = useFetchData();
    const {modalShow, modalType} = UseContext();
    const isSidePanelOpen = modalShow && SIDE_PANEL_MODAL_TYPES.has(modalType);

    useEffect(() => {
        if (Object.keys(userData).length > 0) {
            const userIdentifier = userData._id.toString();
            const hash = CryptoJS.HmacSHA256(userIdentifier, process.env.REACT_APP_INTERCOM_ID).toString();
            Intercom({
                app_id: 'hq7jtuxz',
                user_id: userData._id,
                user_hash: hash,
                name: userData.firstname + ' ' + userData.lastname,
                email: userData.email,
                created_at: userData.createdAt,
                app_type: "Entreprise",
            });
        }
    }, [userData]);

    // The launcher floats over the bottom right corner, where a side panel
    // shows its own content and actions: hidden while one is open.
    // Through the global rather than the SDK's `update`, which memoises
    // window.Intercom on its first call and stays a no-op when that call comes
    // before the asynchronous boot above.
    useEffect(() => {
        if (typeof window.Intercom !== 'function') return;
        window.Intercom('update', {hide_default_launcher: isSidePanelOpen});
    }, [isSidePanelOpen, userData]);

    return (
        <>
            <MediaQuery minWidth={900}>
            <div className="flex h-screen overflow-y-hidden tab:overflow-hidden">
                {/* Sidebar */}
                <SidebarDesktop/>
                {/* Content area */}
                <div className="flex flex-col flex-1 min-h-0 overflow-y-auto overflow-x-hidden" style={{ scrollbarGutter: 'stable' }}>
                    {/* Navbar */}
                    <Navbar></Navbar>
                    <main className="flex flex-col flex-1 min-h-0">
                        {/* SubNav */}
                        {/*<div className="w-full">*/}
                        {/*    <SecondNavBar/>*/}
                        {/*</div>*/}
                        {/* Main Content (pas de gap global: chaque page gère ses marges) */}
                        <div className="flex flex-col flex-1 min-h-0 w-full bg-white tab:pb-0 pb-20">{props.children}</div>
                    </main>
                </div>
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                limit={2}
                pauseOnFocusLoss
                draggable
            />
            </MediaQuery>
            <MediaQuery maxWidth={899}>
                <EmptyStateCompany type={'desktop'}/>
            </MediaQuery>
        </>
    );
};

export default PageForm;